import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ProductCategory, UpdateOrderAction } from '../../services/models/models';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
})
export class MenuComponent {
    @Input()
    menu: ProductCategory[] = []

    @Output()
    select = new EventEmitter<UpdateOrderAction>()
}